import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import ListWrapper from './list-wrapper';

const CheckboxItem = ({
  item,
  handleRemove,
  handleToggleChecked,
  handleKeyDown,
  index,
  autoFocus,
}) => {
  const checkboxRef = useRef(null);

  useEffect(() => {
    if (autoFocus) {
      checkboxRef.current?.focus();
    }
  }, [autoFocus]);

  return (
    <li className="c-letter-slide-list__checkbox-item">
      <input
        className="c-letter-slide-list__checkbox-item__input"
        tabIndex={-1}
        type="checkbox"
        id={`letter-slide-checkbox-item-${index}`}
        name="letterslideCheckbox"
        value={item?.value}
        checked={item?.checked}
        onChange={handleToggleChecked}
      />

      <label
        ref={checkboxRef}
        tabIndex={0}
        onKeyDown={handleKeyDown}
        htmlFor={`letter-slide-checkbox-item-${index}`}
        className={classNames(
          'c-letter-slide-list__checkbox-item__button',
          item?.isDefault
            ? 'c-letter-slide-list__checkbox-item__button--full-width'
            : 'c-letter-slide-list__checkbox-item__button--shortened'
        )}
      >
        <div className="c-letter-slide-list__checkbox-item__icon" aria-hidden />
        <span>{item?.value}</span>
      </label>

      {!item.isDefault && (
        <button
          onClick={handleRemove}
          aria-label={`Ta bort alternativ nummer ${index + 1}`}
        />
      )}
    </li>
  );
};

const MultipleChoiceList = ({ initialData, onUpdate }) => {
  const [listAlternatives, setListAlternatives] = useState(initialData);
  const [newItem, setNewItem] = useState('');

  const handleInputChange = (e) => {
    setNewItem(e.target.value);
  };

  const handleToggleChecked = (index) => {
    setListAlternatives((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, checked: !item.checked } : item
      )
    );
  };

  const handleRemove = (indexToRemove) => {
    setListAlternatives((prevList) =>
      prevList.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleKeyDown = (event, index) => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      handleToggleChecked(index);
    }
  };

  const handleAddClick = () => {
    if (newItem?.trim()) {
      setListAlternatives((prev = []) => [
        ...prev,
        { value: newItem.trim(), checked: true, isDefault: false },
      ]);
      setNewItem('');
    }
  };

  useEffect(() => {
    onUpdate(listAlternatives);
  }, [listAlternatives]);

  return (
    <ListWrapper
      newItem={newItem}
      hasSingleItem={listAlternatives?.length === 1}
      handleInputChange={handleInputChange}
      handleAddClick={handleAddClick}
      placeholderText="Skriv in ett alternativ"
      ariaLabel="Fyll i ett checkbox-alternativ"
      autoFocusInput={false}
    >
      {listAlternatives?.map((item, i) => (
        <CheckboxItem
          key={i}
          item={item}
          index={i}
          handleToggleChecked={() => handleToggleChecked(i)}
          handleRemove={() => handleRemove(i)}
          handleKeyDown={(e) => handleKeyDown(e, i)}
          autoFocus={i === 0}
        />
      ))}
    </ListWrapper>
  );
};

export default MultipleChoiceList;
